import { useTranslation } from "react-i18next";

import type { Profile } from "@/api/bale.zod";

import { useCreateFriendRequest, useDismissFriendRequest, useListFriendRequestsSuspense } from "@/api/bale";
import { ActionBox } from "@/components/ActionBox";
import { Card, CardSubtitleHeader } from "@/components/Card";
import { IconButton } from "@/components/IconButton";
import { ProfileItem } from "@/components/ProfileItem";

export function ReceivedFriendRequests() {
  const { t } = useTranslation();
  const receivedFriendRequests = useListFriendRequestsSuspense({
    query: { select: (data) => data.data.received_friend_requests },
  });
  if (receivedFriendRequests.data.length === 0) return null;

  return (
    <Card>
      <CardSubtitleHeader>{t("received-friend-requests")}</CardSubtitleHeader>
      <div className="flex flex-col gap-4">
        {receivedFriendRequests.data.map((req) => (
          <ReceivedFriendRequest key={req.profile.id} profile={req.profile} />
        ))}
      </div>
    </Card>
  );
}

function ReceivedFriendRequest({ profile }: { profile: Profile }) {
  const dismissFriendRequest = useDismissFriendRequest();
  const acceptFriendRequest = useCreateFriendRequest();

  return (
    <div className="flex flex-row justify-between gap-4 p-2 pl-4">
      <ProfileItem profile={profile} />
      <ActionBox>
        <IconButton
          type="button"
          name="x"
          onClick={() => dismissFriendRequest.mutate({ data: { friend_id: profile.id } })}
        />
        <IconButton
          type="button"
          name="check"
          onClick={() => acceptFriendRequest.mutate({ data: { friend_id: profile.id, note: null } })}
        />
      </ActionBox>
    </div>
  );
}
